import { useMutation } from '@apollo/client'
import { AddInvoiceVariables } from '../../types'
import { ADD_INVOICE } from './operations'

interface AddInvoice {
  inputData: [string]
  addInvoice: string
}

export const addInvoice = () => useMutation<
  AddInvoice,
  AddInvoiceVariables
>(ADD_INVOICE)
